import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a8e5b2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userSet" }

import { api_cw_set_info } from "@/api/home";
import router from "@/router";
import store from "@/store";
import { ref, reactive } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'userSet',
  setup(__props) {

const user = JSON.parse(store.state.user);

let FormData = reactive({
    mobile: '',
    old_pwd: '',
    pwd: ''
})

const logOutFun = () => {
    localStorage.clear();
    sessionStorage.clear();
    router.push('/')
}


const api_cw_set_infoFun = async () => {
    let up = {
        openid: user.openid,
        mobile: FormData.mobile,
        old_pwd: FormData.old_pwd,
        pwd: FormData.pwd
    }

    console.log(up);

    let data: any = await api_cw_set_info(up);

    if (data.error === 0) {
        logOutFun();
    }
    console.log(data);

}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      layout: "vertical",
      model: _unref(FormData),
      onFinish: api_cw_set_infoFun
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "账号" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _unref(FormData).mobile,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(FormData).mobile) = $event)),
              placeholder: "请输入账号"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "旧密码" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _unref(FormData).old_pwd,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(FormData).old_pwd) = $event)),
              placeholder: "请输入旧密码"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "新密码" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _unref(FormData).pwd,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(FormData).pwd) = $event)),
              placeholder: "请输入新密码"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})